import { createApiSlice } from "@common";
import {
    MY_INFO_PASSPORT,
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addMyInfopassport",
        method: "post",
        url: MY_INFO_PASSPORT,
        stateKey: "message",
    },
    {
        name: "getMyInfopassport",
        method: "get",
        url: MY_INFO_PASSPORT,
        stateKey: "data",
    },
    {
        name: "updateMyInfopassport",
        method: "put",
        url: MY_INFO_PASSPORT,
        stateKey: "message",
    },
    {
        name: "deleteMyInfopassport",
        method: "delete",
        url: MY_INFO_PASSPORT,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "MyInfopassport",
    apiConfig,
    customReducers,
);
const MyInfopassportSlice = slice;
// Export the slice's reducer
export default MyInfopassportSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addMyInfopassport,
    getMyInfopassport,
    updateMyInfopassport,
    deleteMyInfopassport
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
